import { NavLink, useLocation, useParams } from "react-router-dom";
import ChevronArrowDown from "assets/icons/chevron-arrow-down.svg?react";
import heartRoundedIcon from "assets/icons/heartroundedIcon.svg";
import StoreButton from "components/Common/Navigation/StoreButton";
import FavoritesButton from "components/Common/Navigation/FavoritesButton";
import { useCartStore } from "stores/cart/useCartStore";
import { useAuthStore } from "stores/auth/authStore";
import { useNavigate } from "react-router-dom";
import { useScrollStore } from "stores/scroll/useScrollStore";
import UserAuthorizedTab from "components/Common/UserAuthorizedTab";
import Button from "components/Buttons";
import { UnionIcon } from "components/Icons";

export default function DesktopNavigation({ handleMouseEnter, handleMouseLeave, onSignUpHandler, onSignInHandler, onSignOutHandler, favouriteSaddleData }) {
  const user = useAuthStore((state) => state.user);
  const subdomain = useAuthStore((state) => state.domain);
  const setToggle = useAuthStore((state) => state.setToggle);
  const userCartData = useCartStore((state) => state.userCartData);

  const scrollToFirstSection = useScrollStore(
    (state) => state.scrollToFirstSection
  );
  const scrollToSecondSection = useScrollStore(
    (state) => state.scrollToSecondSection
  );
  const scrollToThirdSection = useScrollStore(
    (state) => state.scrollToThirdSection
  );
  const filteredItems = userCartData?.items?.filter(
    (item) => item?.productData?.status === "SELL_LIVE"
  );

  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const isSubdomain = Boolean(subdomain);

  return (
    <div className="hidden ml-[40px] lg:flex items-center lg:gap-[20px] xl:gap-[40px]">
      {user ? (
        <>
          {!isSubdomain && user && (
            <div
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              className="flex flex-row items-center gap-x-2 py-1 pl-2 pr-1 rounded-lg hover:bg-[rgba(255,255,255,0.08)] cursor-pointer"
            >
              <NavLink
                to="/buy"
                className={`nav_links text-[16px] ${location.pathname === "/buy" ||
                    location.pathname === `/saddle/${params?.id}`
                    ? "border-b-2 border-[#5C80B6]"
                    : ""
                  } text-[#F7F7F6] hover:cursor-pointer font-medium`}
              >
                Buy a Saddle
              </NavLink>
              <ChevronArrowDown />
            </div>
          )}

          <NavLink
            to="/event"
            className={`nav_links text-[16px] ${location.pathname === "/event"
                ? "border-b-2 border-[#5C80B6]"
                : ""
              } text-[#F7F7F6] hover:cursor-pointer font-medium`}
          >
            Schedule Now
          </NavLink>

          {user && (
            <>
              <div className="relative">
                <StoreButton
                  className={"text-transparent bg-transparent"}
                />
                {filteredItems?.length > 0 && (
                  <div className="bg-red-500 w-6 h-6 text-[12px] cartItemNumber rounded-full  text-white absolute top-[-16px] right-[-18px] flex justify-center items-center">
                    {filteredItems?.length}
                  </div>
                )}
              </div>

              <div className="relative">
                <FavoritesButton
                  className={"text-transparent bg-transparent"}
                />
                {favouriteSaddleData?.listSaddleFavorites?.length >
                  0 && (
                    <img
                      src={heartRoundedIcon}
                      alt="heartRoundedIcon"
                      className="absolute top-0 right-[-2px]"
                    />
                  )}
              </div>
            </>
          )}

          <UserAuthorizedTab />
          <Button
            size
            whiteOutline
            className={"nav_outline_btn"}
            transparent
            onClick={onSignOutHandler}
          >
            Sign out
          </Button>
        </>
      ) : (
        <>
          <ul className="lg:flex gap-x-8 lg:gap-x-4 xl:gap-x-8">
            {isSubdomain ? (
              <NavLink
                to="/event"
                className={`nav_links text-[16px] ${location.pathname === "/event"
                    ? "border-b-2 border-[#5C80B6]"
                    : ""
                  } text-[#F7F7F6] hover:cursor-pointer font-medium`}
              >
                Schedule Now
              </NavLink>
            ) : (
              <>
                <span
                  onClick={() => {
                    if (location.pathname !== "/") {
                      setToggle(false);
                      navigate("/");
                      setTimeout(() => {
                        scrollToFirstSection();
                      }, 0);
                    } else {
                      setToggle(false);
                      scrollToFirstSection();
                    }
                  }}
                  className="nav_links text-[16px] text-[#F7F7F6] hover:cursor-pointer font-medium"
                >
                  Why SaddleFit
                </span>
                <span
                  onClick={() => {
                    if (location.pathname !== "/") {
                      setToggle(false);
                      navigate("/");
                      setTimeout(() => {
                        scrollToSecondSection();
                      }, 0);
                    } else {
                      setToggle(false);
                      scrollToSecondSection();
                    }
                  }}
                  className="nav_links text-[16px] text-[#F7F7F6] hover:cursor-pointer font-medium"
                >
                  How it works
                </span>
                {/* please add link to the booking portion of the page */}
                <span
                  onClick={() => {
                    if (location.pathname !== "/") {
                      setToggle(false);
                      navigate("/", {
                        // state: { scrollToSecFive: true },
                      });
                      setTimeout(() => {
                        scrollToThirdSection();
                      }, 0);
                    } else {
                      setToggle(false);
                      scrollToThirdSection();
                    }
                  }}
                  className="nav_links text-[16px] text-[#F7F7F6] hover:cursor-pointer font-medium"
                >
                  Book Appointment
                </span>

                <div
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                  className="flex flex-row items-center gap-x-2 pl-2 pr-1 rounded-lg hover:bg-[rgba(255,255,255,0.08)] cursor-pointer"
                >
                  <NavLink
                    to="/buy"
                    className={`nav_links text-[16px] ${location.pathname === "/buy" ||
                        location.pathname === `/saddle/${params?.id}`
                        ? "border-b-2 border-[#5C80B6]"
                        : ""
                      } text-[#F7F7F6] hover:cursor-pointer font-medium`}
                  >
                    Buy a Saddle
                  </NavLink>
                  <ChevronArrowDown />
                </div>

                <NavLink
                  to="/event"
                  className={`nav_links text-[16px] ${location.pathname === "/event"
                      ? "border-b-2 border-[#5C80B6]"
                      : ""
                    } text-[#F7F7F6] hover:cursor-pointer font-medium`}
                >
                  Schedule Now
                </NavLink>
              </>
            )}
          </ul>
          <div className="flex lg:w-auto w-[220px] justify-end sm:flex sm:justify-end md:justify-between lg:justify-around items-center">
            <div className=" lg:flex items-center gap-[10px]">
              <Button
                size
                whiteOutline
                className={"nav_outline_btn"}
                transparent
                onClick={onSignInHandler}
              >
                Sign in
              </Button>
              <Button
                size
                className={"nav_btn"}
                AppendIcon={UnionIcon}
                onClick={onSignUpHandler}
              >
                Join now
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}